/**
 * Homepage partner testimonials Swiper carousel.
 *
 * @package WPSCT
 */

export class TestimonialsSlider {
  constructor() {
    this.init();
  }

  /**
   * Initialize all testimonial sliders on the page.
   */
  init() {
    if (typeof Swiper === "undefined") {
      return;
    }

    const sliders = document.querySelectorAll(".wps-home-testimonials__slider");

    sliders.forEach((slider) => {
      if (slider.swiper) {
        return;
      }

      const slideCount = slider.querySelectorAll(".swiper-slide").length;
      const enableLoop = slideCount > 1;

      // eslint-disable-next-line no-new
      new Swiper(slider, {
        slidesPerView: "auto",
        centeredSlides: true,
        loop: enableLoop,
        speed: 700,
        spaceBetween: 160,
        grabCursor: true,
        autoplay: enableLoop
          ? {
              delay: 5000,
              disableOnInteraction: false,
            }
          : false,
        breakpoints: {
          0: {
            spaceBetween: 24,
          },
          768: {
            spaceBetween: 80,
          },
          1200: {
            spaceBetween: 160,
          },
        },
      });
    });
  }
}
